import { render } from "./TemplatePass.vue?vue&type=template&id=6bbc76c3&scoped=true"
import script from "./TemplatePass.vue?vue&type=script&lang=js"
export * from "./TemplatePass.vue?vue&type=script&lang=js"

import "./TemplatePass.vue?vue&type=style&index=0&id=6bbc76c3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bbc76c3"

export default script